var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"superslide-container"},[(!_vm.position)?_vm._t("pagination"):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.position)?_vm._t("pagination"):_vm._e(),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f3721e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/vue-superslide/superslide/src/superslide.vue
// module id = null
// module chunks = 